'use client';

import { Eye, Target } from 'lucide-react';
import { motion } from 'framer-motion';

export default function AboutUsSection() {
  return (
    <section className="py-16 px-4 max-w-6xl mx-auto text-center">
      {/* Heading */}
      <h2 className="text-3xl font-semibold mb-2">
        About <span className="text-orange-500">Us</span>
      </h2>
      <p className="text-gray-700 max-w-6xl mx-auto mb-12 text-sm sm:text-base">
        At Hiblink, we help U.S. entrepreneurs and executives buy their time back. Based in Ethiopia, we provide highly trained, English-proficient professionals who seamlessly extend your team and handle the work that slows you down. From administration and customer support to social media management and IT services, we take the operational load off your shoulders. We don’t just deliver tasks. We deliver reliability, consistency, and peace of mind. With Hiblink, you’re not hiring help — you’re gaining a partner in execution.
      </p>

      {/* Animated Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left">
        {/* Vision */}
        <motion.div
          initial={{ scale: 0.6, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          transition={{ duration: 1, delay: 0.2, type: 'spring' }}
          viewport={{ once: true }}
          className="bg-white rounded-lg shadow-md p-6"
        >
          <div className="flex items-center mb-4">
            <div className="bg-cyan-200 p-2 rounded-full mr-3">
              <Eye className="text-white w-6 h-6" />
            </div>
            <h3 className="text-xl font-bold border-b-4 border-orange-500 inline-block pb-1">Vision</h3>
          </div>
          <p className="text-gray-700 text-sm sm:text-base">
            To be the go-to link between global companies and Ethiopia’s rising workforce — driving growth,
            opportunity, and meaningful change through excellence.
          </p>
        </motion.div>

        {/* Mission */}
        <motion.div
          initial={{ scale: 0.6, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.4, type: 'spring' }}
          viewport={{ once: true }}
          className="bg-white rounded-lg shadow-md p-6"
        >
          <div className="flex items-center mb-4">
            <div className="bg-cyan-200 p-2 rounded-full mr-3">
              <Target className="text-white w-6 h-6" />
            </div>
            <h3 className="text-xl font-bold border-b-4 border-orange-500 inline-block pb-1">Mission</h3>
          </div>
          <p className="text-gray-700 text-sm sm:text-base">
            Hiblink unlocks business growth by connecting U.S. entrepreneurs with skilled, trusted virtual
            teams based in Ethiopia — delivering seamless, scalable support.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
